var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artists",attrs:{"id":"artists"}},[_c('chief-whip'),_c('soulcraft'),_c('testimonials')],1)}
var staticRenderFns = []

export { render, staticRenderFns }